var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEasyFarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 154,
    viewBox: "0 0 254 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.641 76.6794L177.32 0L254 76.6794H100.641Z",
    fill: "url(#paint0_linear_181_57)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4831 76.6795L152.16 0.00268555L228.837 76.6795H75.4831Z",
    fill: "url(#paint1_linear_181_57)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3203 76.6794L127 0L203.679 76.6794H50.3203Z",
    fill: "url(#paint2_linear_181_57)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1628 76.6795L101.84 0.00268555L178.516 76.6795H25.1628Z",
    fill: "url(#paint3_linear_181_57)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34798e-06 76.6794L76.6794 0L153.359 76.6794H1.34798e-06Z",
    fill: "url(#paint4_linear_181_57)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181_57",
    x1: 138.982,
    y1: 38.3384,
    x2: 215.661,
    y2: 115.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1971FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_181_57",
    x1: 113.822,
    y1: 38.3411,
    x2: 190.498,
    y2: 115.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1971FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_181_57",
    x1: 88.6614,
    y1: 38.3384,
    x2: 165.341,
    y2: 115.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1971FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_181_57",
    x1: 63.5012,
    y1: 38.3411,
    x2: 140.178,
    y2: 115.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1971FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010F4A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_181_57",
    x1: 38.3384,
    y1: 38.341,
    x2: 115.018,
    y2: 115.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1971FF",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010F4A",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyFarm);
export default __webpack_public_path__ + "static/media/easy-farm.18ee2ec04153c2dcd67afe21a21b966d.svg";
export { ForwardRef as ReactComponent };